/**
 * TODO mehrere parents (z.B. sidebar, pictureSets) also createMany() kann auch referenzen auf bestehende routen erzeugen?
 * TODO check -> update  => explore -> prepare(async part) -> transition (parser/digest)
 */
export class Route extends EventTarget {
    name = '';
    rules = [];
    params;
    /**
     * TODO nextParams muss in den Parser
     * TODO d.h. über die route gibt es keinen zugriff auf nextParams, nur in der middleware
     * TODO also müssen middlewares, die auf nextParams anderer route zugreifen irgendwas anders machen als bisher
     */
    nextParams = Object.create(null);
    isActive = false;
    nextActive = false;
    /**
     * TODO statt isVirtual ein requires-array mit bedingungen oder pre-check und post-check
     */
    isVirtual = false;
    entered_at = null;
    left_at = null;
    history = [];
    count = 0;
    routes = [];
    wait = false;
    promises = [];
    // TODO with this multiple roots are impossible
    // TODO solution: make parser/digest objects
    static lastIndex = 0;
    static lastIndexMax = 0;
    VERBOSE = true; // only in debug! typescript fuckup
    constructor(parentRoute) {
        super();
        this.VERBOSE = parentRoute?.VERBOSE ?? false;
        if (parentRoute) {
            this.params = Object.create(parentRoute.params);
            parentRoute.routes.push(this);
        }
        else {
            this.params = {};
        }
    }
    create(...config) {
        return new Route(this).config(...config);
    }
    createMany(...configs) {
        return configs.map(config => this.create(...config));
    }
    config(...config) {
        for (const decorator of config) {
            decorator(this);
        }
        return this;
    }
    // TODO find sollte global alle aliase durchsuchen und nicht nur auf diesem subtree
    find(alias) {
        if (this.name == alias) {
            return this;
        }
        let found = null;
        for (const route of this.routes) {
            found = route.find(alias);
            if (found) {
                return found;
            }
        }
        return null;
    }
    check(pathname, failed = false) {
        const saveLastIndex = Route.lastIndex;
        let success = false;
        if (failed || !this.#execMiddlewares(pathname)) {
            this.nextActive = false;
            if (this.isActive) {
                for (const route of this.routes) {
                    route.check(pathname, true);
                }
            }
        }
        else {
            success = !this.isVirtual;
            this.nextActive = true;
            this.wait = this.promises.length ? Promise.all(this.promises) : false;
            for (const route of this.routes) {
                if (route.check(pathname)) {
                    success = true;
                }
            }
        }
        Route.lastIndex = saveLastIndex;
        return success;
    }
    // TODO sobald ein promise zurückgegeben wird, wird der rest zu einer promise chain
    #execMiddlewares(pathname) {
        for (const key in this.nextParams) {
            delete this.nextParams[key];
        }
        this.wait = false;
        this.promises.length = 0;
        for (const rule of this.rules) {
            const saveLastIndex = Route.lastIndex;
            const result = rule(this.nextParams, this.params, pathname);
            if (!result) {
                if (result === undefined) {
                    continue;
                }
                Route.lastIndex = saveLastIndex;
                DEBUG: this.VERBOSE && console.debug('voyager/route middleware failed', { route: this, rule });
                return false;
            }
            if (result === true) {
                continue;
            }
            if (result instanceof Object && result.then instanceof Function) {
                this.promises.push(result);
                continue;
            }
            throw new Error(`The return value ´${result}´ of a route rule ´${rule}´ is illegal.`);
        }
        return true;
    }
    /*
     * Compare the parameter `key` from current to next path.
     */
    same(key) {
        return this.params[key] === this.nextParams[key];
    }
    /*
     * Transfer the parameter `key` from current to next path.
     */
    keep(key) {
        this.nextParams[key] = this.params[key];
    }
    set(key, value) {
        this.nextParams[key] = value;
    }
    /*
     * TODO bei erfolg pushstate-url setzen!?
     * TODO nicht nur bei exception inactive sondern auch wenn mit false resolved wird
     */
    update(globals, goneAsync = false) {
        if (!this.nextActive || !globals) {
            this.handleNextInactive();
            return;
        }
        if (!this.wait) {
            return this.handleNextActive(globals, goneAsync);
        }
        else {
            DEBUG: this.VERBOSE && console.info('voyager/route update async', { alias: this.name, route: this });
            return this.wait
                .then(() => {
                DEBUG: this.VERBOSE && console.group('voyager/route async active', { alias: this.name });
                const res = this.handleNextActive(globals, true);
                DEBUG: this.VERBOSE && console.groupEnd();
                return res;
            })
                .catch(reason => {
                console.error('voyager/route async inactive', reason);
                DEBUG: this.VERBOSE && console.group('voyager/route async inactive', { alias: this.name, reason });
                this.error(reason, true);
                // TODO maybe set nextActive = false
                this.handleNextInactive();
                DEBUG: this.VERBOSE && console.groupEnd();
            });
        }
    }
    // TODO handle exception in listeners
    handleNextActive(globals, goneAsync = false) {
        DEBUG: this.VERBOSE && console.debug('voyager/route active', { alias: this.name, route: this });
        if (this.isActive) {
            for (const [key, value] of Object.entries(this.nextParams)) {
                if (this.params[key] !== value) {
                    DEBUG: this.VERBOSE && console.group('parameter change');
                    this.handleNextInactive();
                    DEBUG: this.VERBOSE && console.groupEnd();
                    break;
                }
            }
        }
        Object.assign(globals, this.nextParams);
        if (!this.isActive) {
            for (const key of Object.keys(this.params)) {
                if (this.nextParams[key] === undefined) {
                    delete this.params[key];
                }
            }
            Object.assign(this.params, this.nextParams);
            this.enter(goneAsync);
            this.change(goneAsync);
        }
        else {
            this.nochange(goneAsync);
        }
        this.active(goneAsync);
        const childUpdates = this.routes
            .map(route => route.update(globals, goneAsync)) //
            .filter(res => !!res);
        if (!childUpdates.length) {
            // keep it in sync
            return;
        }
        return Promise.all(childUpdates);
    }
    // TODO exceptions dürften hier eigentlich nicht fliegen
    handleNextInactive() {
        if (this.isActive) {
            for (const route of this.routes) {
                route.update();
            }
            DEBUG: this.VERBOSE && console.debug('voyager/route leave', { alias: this.name, route: this });
            this.leave();
            for (const p of Object.keys(this.params)) {
                delete this.params[p];
            }
            this.change();
        }
    }
    enter(goneAsync = false) {
        this.isActive = true;
        this.count++;
        this.entered_at = new Date();
        this.dispatchEvent(new CustomEvent('enter', { detail: { route: this, goneAsync } }));
    }
    leave() {
        this.isActive = false;
        this.left_at = new Date();
        this.history.push([
            this.entered_at,
            this.left_at,
            //structuredClone(this.params),
        ]);
        this.dispatchEvent(new CustomEvent('leave', { detail: { route: this } }));
    }
    change(goneAsync = false) {
        this.dispatchEvent(new CustomEvent('change', { detail: { route: this, goneAsync } }));
    }
    nochange(goneAsync = false) {
        this.dispatchEvent(new CustomEvent('nochange', { detail: { route: this, goneAsync } }));
    }
    active(goneAsync = false) {
        this.dispatchEvent(new CustomEvent('active', { detail: { route: this, goneAsync } }));
    }
    error(reason, goneAsync = false) {
        this.dispatchEvent(new CustomEvent('error', { detail: { route: this, reason, goneAsync } }));
    }
    getTotalTime() {
        return this.history.reduce(
        //
        (acc, cur) => cur[1].getTime() - cur[0].getTime() + acc, 0);
    }
}
